<template>
	<select :id="'subforestry_id_' + this.id" v-model="selected" class='form-control table-control my-control' data-num='f_27' data-table='1' disabled>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const SUBFORESTRY = 'subforestrie_list.php'
	//const HEADER = 'get_header.php'
	const LOCATION = 'get_warrant_location.php'

	import {EventBus} from '../../../lib/EventBus'
	
	export default {
		name: 'subforestry',
		data: function () { 
			return {
				id: `${this.type}_localforestry_${this.line_count}`,
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: ''
		},
		created: function () {
			fetch(DB + LOCATION + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				const lf = res.filter(item => {
					return item.field == 'f_20'
				})
				const sf = res.filter(item => {
					return item.field == 'f_27'
				})
				if (lf[this.line_count]) 
					if (sf[this.line_count])
						return {localforestry_id: lf[this.line_count].val, subforestry_id: sf[this.line_count].val}
					else
						return {localforestry_id: lf[this.line_count].val, subforestry_id: '0'}
				else
					return {localforestry_id: '0', subforestry_id: '0'}
			})
			.then(location => {
				fetch(DB + SUBFORESTRY + '?id=' + location.localforestry_id)
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [...data];
						//this.options.forEach(a => console.log(a.name))
						this.selected = !location.subforestry_id ?  '0' : location.subforestry_id

						let sf = this.options.filter(item => {
							return item.id == location.subforestry_id
						})

						if (sf.length > 0) {
							EventBus.$emit('warrant_subforestry', {index: this.line_count, value: this.selected, text: sf[0].name})
						}
						else {
							EventBus.$emit('warrant_subforestry', {index: this.line_count, value: this.selected, text: '-'})
						}
						//console.log(data[this.line_count+1].name, this.line_count, location.localforestry_id, location.subforestry_id)
					}
					else {
						this.selected = '0'
						this.options = []
					}
				})
				.catch(err => console.log('4',err))
			})
			.catch(err => console.log('5',err))
		}
	}
</script>


// WEBPACK FOOTER //
// subforestry.vue?4366d255